import { useDispatch, useSelector } from "react-redux";
import {
  uploadInvoiceRequest,
  uploadInvoiceSuccess,
} from "../../store/claim/actions";
import { useEffect, useState } from "react";
import { DatePicker, InputText } from "../../components";
import { useFormContext } from "react-hook-form";
import { FiEye, FiTrash2, FiFile } from "react-icons/fi";

function PurchaseDetails() {
  const {
    control,
    register,
    formState: { errors },
    setValue,
  } = useFormContext();
  const dispatch = useDispatch();
  const [uploadedFileName, setUploadedFileName] = useState<string>("");

  const uploadedInvoiceUrl = useSelector(
    // @ts-ignore
    (state) => state?.claim?.uploadedInvoiceUrl || null
  );

  useEffect(() => {
    if (uploadedInvoiceUrl) {
      setValue("purchase_info.uploaded_invoice_url", uploadedInvoiceUrl);
      const fileName = uploadedInvoiceUrl.split("/").pop() || "uploaded-file";
      setUploadedFileName(fileName);
    }
  }, [uploadedInvoiceUrl, setValue]);

  const handleDeleteFile = () => {
    dispatch(uploadInvoiceSuccess({ url: null }));
    setValue("purchase_info.uploaded_invoice_url", "");
    setValue("purchase_info.invoice_file", null);
    setUploadedFileName("");
  };

  const handleViewFile = () => {
    if (uploadedInvoiceUrl) {
      window.open(uploadedInvoiceUrl, "_blank");
    }
  };

  return (
    <>
      <div className="mb-8 space-y-3">
        <InputText
          label="Name on the invoice"
          control={control}
          required
          name="purchase_info.name_on_invoice"
        />
        <InputText
          label="Invoice number"
          control={control}
          required
          name="purchase_info.invoice_number"
        />
        <div className="flex flex-col gap-1">
          <label className="text-base ml-1 mb-0.5 block">
            <span>Upload Invoice/Receipt</span>
          </label>

          {!uploadedInvoiceUrl ? (
            <>
              <input
                type="file"
                accept="image/*,application/pdf"
                {...register("purchase_info.invoice_file", {
                  onChange: (e) => {
                    const file = e.target.files[0];
                    if (file) {
                      setUploadedFileName(file.name);
                      dispatch(uploadInvoiceRequest(file));
                    }
                  },
                  validate: {
                    fileSize: (value) => {
                      if (!value || !value[0]) return true;
                      return (
                        value[0].size <= 20 * 1024 * 1024 ||
                        "File size should be less than 20MB"
                      );
                    },
                    fileType: (value) => {
                      if (!value || !value[0]) return true;
                      return (
                        value[0].type === "application/pdf" ||
                        value[0].type.startsWith("image/") ||
                        "Only PDF and Image files are allowed"
                      );
                    },
                  },
                })}
                className="placeholder:text-gray-500 border-gray-200 rounded-lg w-full px-2.5 py-2 border focus:border-brand-secondary-hover focus-within:border-brand-secondary-hover focus:bg-[#eaf1fa] transition-all outline-none bg-white"
              />
              {/* @ts-ignore */}
              {errors?.purchase_info?.invoice_file && (
                <p className="text-red-600 font-normal text-sm m-0 p-0 ml-1  bottom-0 left-0 right-0">
                  {/* @ts-ignore */}
                  {errors?.purchase_info?.invoice_file?.message}
                </p>
              )}
            </>
          ) : (
            <div className="border border-green-200 bg-green-50 rounded-lg p-3 flex items-center justify-between">
              <div className="flex items-center gap-2 flex-1 min-w-0">
                <FiFile className="text-green-600 flex-shrink-0" size={20} />
                <div className="flex-1 min-w-0">
                  <p className="text-sm font-medium text-green-800 truncate">
                    {uploadedFileName || "Uploaded File"}
                  </p>
                  <p className="text-xs text-green-600">
                    File uploaded successfully
                  </p>
                </div>
              </div>
              <div className="flex items-center gap-2 ml-2">
                <button
                  type="button"
                  onClick={handleViewFile}
                  className="p-2 hover:bg-green-100 rounded-lg transition-colors"
                  title="View file"
                >
                  <FiEye className="text-green-700" size={18} />
                </button>
                <button
                  type="button"
                  onClick={handleDeleteFile}
                  className="p-2 hover:bg-red-100 rounded-lg transition-colors"
                  title="Delete file"
                >
                  <FiTrash2 className="text-red-600" size={18} />
                </button>
              </div>
            </div>
          )}
        </div>
        <DatePicker
          label="Date of Purchase"
          control={control}
          required
          name="purchase_info.date_of_purchase"
          placeholder="Date of Purchase"
          disableFuture
        />
      </div>
    </>
  );
}

export default PurchaseDetails;
